// extracted by mini-css-extract-plugin
module.exports = {"grid":"src-screens-Appointments-Appointments-module__grid--2IE7Q","gridChild":"src-screens-Appointments-Appointments-module__gridChild--3CyIU"};